module.exports = __webpack_public_path__ + "assets/images/Radiation_warning_symbol.svg";